import { LoadingStatus } from '@shared/models/loading-status';

export const defaultLoadingStatus: LoadingStatus = {
  loaded: false,
  loading: false,
  updated: false,
  updating: false,
};
